export default "__VITE_ASSET__DWig0YdH__"